export const ICON_SIZES = {
  sm: 14,
  md: 16,
  lg: 18,
} as const;

export const ICON_STROKE = 1;
